import { cn } from "@newxsystems/shared";
import { TootLogoStrip } from "../../../../modules/content/components/TootLogoStrip/TootLogoStrip";

import { TootActions } from "../../../../modules/layout/components/TootActions/TootActions";
import { TootHeading } from "../../../../modules/layout/components/TootHeading/TootHeading";

import { TootSectionShell } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell";
import type { TootSectionTone } from "../../../../modules/layout/components/TootSectionShell/TootSectionShell.props";
import type { ILogoProofBlockProps } from "./LogoProofBlock.props";

const captionToneClasses: Record<TootSectionTone, string> = {
  default: "text-muted-foreground",
  muted: "text-muted-foreground",
  dark: "text-toot-muted",
  accent: "text-toot-muted",
};

export const LogoProofBlock = (props: ILogoProofBlockProps) => {
  const { anchorId, caption, eyebrow, heading, parentClass, subheading } = props;
  const alignment = "center" as const;
  const actions = props.buttons ?? [];
  const logoItems = props.logos ?? [];
  const sectionId = anchorId ?? undefined;
  const hasHeader = Boolean(eyebrow || heading || subheading);
  const tone: TootSectionTone = "default";

  return (
    <TootSectionShell
      className="relative flex flex-col gap-6 lg:gap-8"
      containerClassName="relative"
      header={
        hasHeader ? (
          <TootHeading
            alignment={alignment}
            className="max-w-[64rem] [&_.toot-heading-section]:[overflow-wrap:anywhere] [&_.toot-subheading]:max-w-[43rem] [&_.toot-subheading]:text-[color-mix(in_oklab,var(--color-toot-foreground)_78%,transparent)]"
            eyebrow={eyebrow}
            heading={heading}
            inverse={false}
            subheading={subheading}
          />
        ) : null
      }
      id={sectionId}
      rootClassName={parentClass}
      spacing={props.spacing ?? undefined}
      tone={tone}
      width="wide"
    >
      <TootLogoStrip logos={logoItems} />

      {caption || actions.length > 0 ? (
        <div
          className={cn(
            "mx-auto flex w-full max-w-4xl flex-col gap-4 rounded-[var(--radius-toot-frame)] border border-[color-mix(in_oklab,var(--color-toot-grid-strong)_72%,transparent)] bg-[color-mix(in_oklab,var(--color-toot-black)_58%,transparent)] p-4 text-sm leading-6 shadow-inner sm:flex-row sm:items-center sm:justify-between sm:p-5",
            captionToneClasses[tone],
            "items-center text-center sm:justify-center",
          )}
        >
          {caption ? (
            <p className="m-0 max-w-2xl text-pretty [overflow-wrap:anywhere]">{caption}</p>
          ) : null}
          <TootActions actions={actions} alignment={alignment} />
        </div>
      ) : null}
    </TootSectionShell>
  );
};

LogoProofBlock.displayName = "Block::LogoProofBlock";
